import { url } from '@/config';
import request from '@/router/axios';
export var getList = function getList(params) {
  return request({
    url: url + '/category/list',
    method: 'get',
    params: params
  });
};
export var getObj = function getObj(id) {
  return request({
    url: url + '/category/detail',
    method: 'get',
    params: {
      id: id
    }
  });
};
export var addObj = function addObj(data) {
  return request({
    url: url + '/category/save',
    method: 'post',
    data: data
  });
};
export var updateObj = function updateObj(data) {
  return request({
    url: url + '/category/update',
    method: 'post',
    data: data
  });
};
export var delObj = function delObj(id) {
  return request({
    url: url + '/category/remove',
    method: 'post',
    params: {
      ids: id
    }
  });
};